import React, { useState } from "react";
import "./AboutUs.css";

import PDF from "../Data/Resume.pdf";

import { DownloadOutlined, CaretRightOutlined } from "@ant-design/icons";
import { message } from "antd";

import Icon1 from "../Icon/scholarship.png";
import Icon2 from "../Icon/businessman.png";
import Img1 from "../Img/education-img.jpg";

export default function AboutUs() {
  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    messageApi
      .open({
        type: "loading",
        content: "Downloading..",
        duration: 2.5,
      })
      .then(() => {
        const link = document.createElement("a");
        link.href = PDF;
        link.download = "Resume.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("Download successful", 2.5);
      });
  };
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Coming soon..",
    });
  };

  const [page, setPage] = useState(1);

  return (
    <div className="AboutUs-Body">
      {contextHolder}
      <div className="AboutUs-Top-Box">
        <div className="AboutUs-Top-Div">
          <div className="AboutUs-Top-Left">
            <button className="AboutUs-Left-Button2" onClick={error}>
              <CaretRightOutlined />
            </button>

            <button className="AboutUs-Left-Button" onClick={success}>
              Get Resume
              <DownloadOutlined />
            </button>
            
          </div>
          <div className="AboutUs-Top-Right">
            <p className="AboutUs-Text1">I’m Tasnim Shahriar Akash</p>
            <p className="AboutUs-Text2">
              Software engineer specializing in MERN Stack.
            </p>
            <p className="AboutUs-Text3">
              Al Helal MD Tasnim Shahriar Akash, a passionate and accomplished
              Computer Science & Engineering graduate from Daffodil
              International University, adept in a wide array of programming
              languages and frameworks. Demonstrating a strong commitment to
              software development through diverse projects, seeking to
              contribute innovative solutions and drive organizational growth.
            </p>
          </div>
          <div className="AboutUs-Top-Left2">
            <button className="AboutUs-Left-Button2" onClick={error}>
              <CaretRightOutlined />
            </button>

            <button className="AboutUs-Left-Button" onClick={success}>
              Get Resume
              <DownloadOutlined />
            </button>
          </div>
        </div>
      </div>
      <div className="AboutUs-Down-Body">
        <div className="AboutUs-Down-Box">
          <button
            className="AboutUs-Down-Button"
            onClick={() => {
              setPage(1);
            }}
            style={{
              color: page === 1 ? "#6f62e0" : "#fff",
              borderColor: page === 1 ? "#fb6565" : "#6f62e0",
            }}
          >
            Education
          </button>
          <button
            className="AboutUs-Down-Button"
            onClick={() => {
              setPage(2);
            }}
            style={{
              color: page === 2 ? "#6f62e0" : "#fff",
              borderColor: page === 2 ? "#fb6565" : "#6f62e0",
            }}
          >
            Experience
          </button>
        </div>

        <div style={{ width: "100%" }}>
          {page === 1 ? (
            <div className="AboutUs-Page-Box">
              <AboutUsContent
                text1="Education"
                text2="My Education"
                text3="Graduated with a Bachelor's in Computer Science & Engineering from Daffodil International University, demonstrating a strong academic background."
                icon={Icon1}
                text4="Bachelor in Computer Science & Engineering"
                place="Daffodil International University, Dhaka"
                date="(2019-2023)"
                details="Engaged in diverse extracurricular activities, collaborated on projects, and fostered lasting relationships, enriching my university experience and personal growth."
                text5="Higher Secondary School Certificate"
                place2="Danai College , Dhaka"
                date2="(2017-2018)"
                details2="Thrived academically, participated in clubs, and enjoyed memorable moments with friends, shaping a fulfilling and enriching college journey."
                text6="Secondary School Certificate"
                place3="Lahini Secondary School, Kushtia"
                date3="(2015-2016)"
                details3="School years were formative, fostering curiosity, friendship, and foundational learning experiences, setting the stage for future academic and personal growth."
                img={Img1}
              />
            </div>
          ) : page === 2 ? (
            <div className="AboutUs-Page-Box">
              <AboutUsContent
                text1="Work Experience"
                text2="My Experience"
                text3="My work experience spans various projects in web and application development, honing skills in frontend and backend technologies for impactful solutions."
                icon={Icon2}
                text4="Fiverr"
                place="Freelance"
                date="(2023-2024)"
                details="In my freelance journey, I've collaborated on diverse projects, offering web development services, ensuring client satisfaction through quality deliverables and timely communication."
                text5="UK HR CLOUD"
                place2="Software Developer, Remote"
                date2="(2022-2023)"
                details2="Engaged in remote roles, I've contributed to various projects, leveraging my expertise in web development, fostering teamwork, and meeting project objectives with efficiency."
                text6="Scientistx Technology"
                place3="Software Developer, Dhaka"
                date3="(2022-2022)"
                details3="My work experience spans various projects in web and application development, honing skills in frontend and backend technologies for impactful solutions."
                img={Img1}
              />
            </div>
          ) : (
            <h1> Error page</h1>
          )}
        </div>
      </div>
    </div>
  );
}

function AboutUsContent({
  text1,
  text2,
  text3,
  icon,
  text4,
  place,
  date,
  details,
  text5,
  text6,
  place2,
  place3,
  date2,
  date3,
  details2,
  details3,
  img,
}) {
  return (
    <div className="AboutUsContent-Body">
      <div className="AboutUsContent-Left">
        <p className="AboutUs-Text2">|| {text1}</p>
        <p className="AboutUs-Text1" style={{ marginTop: "-10px" }}>
          {text2}
        </p>
        <p className="AboutUs-Text3" style={{ marginTop: "30px" }}>
          {text3}
        </p>

        <div className="AboutUsContent-Box">
          <div className="AboutUsContent-Box-Left">
            <img alt="" src={icon} className="AboutUsContent-Box-Icon" />
          </div>
          <div className="AboutUsContent-Box-Right">
            <p className="AboutUs-Text4">{text4}</p>
            <p className="AboutUs-Text5">
              {place} <p className="AboutUs-Text6">{date}</p>
            </p>
            <p className="AboutUs-Text7">{details}</p>
          </div>
        </div>

        <div className="AboutUsContent-Box">
          <div className="AboutUsContent-Box-Left">
            <img alt="" src={icon} className="AboutUsContent-Box-Icon" />
          </div>
          <div className="AboutUsContent-Box-Right">
            <p className="AboutUs-Text4">{text5}</p>
            <p className="AboutUs-Text5">
              {place2} <p className="AboutUs-Text6">{date2}</p>
            </p>
            <p className="AboutUs-Text7">{details2}</p>
          </div>
        </div>

        <div className="AboutUsContent-Box">
          <div className="AboutUsContent-Box-Left">
            <img alt="" src={icon} className="AboutUsContent-Box-Icon" />
          </div>
          <div className="AboutUsContent-Box-Right">
            <p className="AboutUs-Text4">{text6}</p>
            <p className="AboutUs-Text5">
              {place3} <p className="AboutUs-Text6">{date3}</p>
            </p>
            <p className="AboutUs-Text7">{details3}</p>
          </div>
        </div>
      </div>
      <div className="AboutUsContent-Right">
        <img src={img} alt="" className="AboutUsContent-Right-Img" />
      </div>
    </div>
  );
}
